/// <reference types="@types/google.maps" />

import { sum } from 'ramda'
import { Renderer } from 'instantsearch.js/es/types'
import connectHits, {
    HitsConnectorParams as CParams,
    HitsWidgetDescription as WDescription,
} from 'instantsearch.js/es/connectors/hits/connectHits'

import { Component, forwardRef, Inject, OnInit } from '@angular/core'
import { Dialog } from '@angular/cdk/dialog'

import { AbstractInstantsearchWidgetComponent } from '@app-domains/algolia/abstract-instantsearch-widget.component'
import { AlgoliaInstantsearchComponent } from '@app-domains/algolia/components/algolia-instantsearch.component'
import { FilterDialogComponent } from '@app-domains/google-maps/components/filter-dialog/filter-dialog.component'
import { googleMapStyle } from '@app-domains/google-maps/types/maps-styles'
import { coordinatesOfDeEekhoornHeadQuarter } from '@app-domains/google-maps/types/locations'

@Component({
    selector: 'app-dealers-hits',
    templateUrl: './dealers-hits.component.html',
})
export class DealersHitsComponent extends AbstractInstantsearchWidgetComponent<
WDescription,
CParams
> implements OnInit {

    public override readonly widgetName = 'Hits'

    public mapOptions: google.maps.MapOptions = {
        center: coordinatesOfDeEekhoornHeadQuarter,
        zoom: 8,
        zoomControl: true,
        styles: googleMapStyle,
        maxZoom: 18,
        gestureHandling: 'cooperative',
        mapTypeControl: false,
        streetViewControl: false,
    }

    public filterCount: number

    constructor(
        @Inject(forwardRef(() => AlgoliaInstantsearchComponent))
        public instantSearchInstance: AlgoliaInstantsearchComponent,
        private dialog: Dialog,
    ) {
        super()
    }

    public override ngOnInit(): void {
        this.createWidget(connectHits, {})
        super.ngOnInit()
    }

    public override updateState: Renderer<WDescription['renderState'], CParams> = (state) => {
        Promise.resolve().then(async () => {
            this.state = state

            const helper = this.instantSearchInstance.instantSearchInstance.helper

            if (helper && helper.state) {
                this.filterCount = sum([
                    ...Object.values(helper.state.disjunctiveFacetsRefinements).map(f => f.length),
                    ...Object.values(helper.state.facetsRefinements).map(f => f.length),
                ])
            }
        })
    }

    public filterClick(): void {
        this.dialog.open(FilterDialogComponent, {
            data: {
                allDealers: this.state?.hits,
                instantSearchInstance: this.instantSearchInstance,
            },
            disableClose: true,
        })
    }

}
